const subscriptions = [
	{
		path: '/network/subscriptions',
		name: 'network-subscriptions-list',
		component: () => import('@/views/network/subscriptions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
	{
		path: '/network/subscriptions/cancellations',
		name: 'network-subscriptions-cancellations',
		component: () => import('@/views/network/subscriptions/cancellations.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,network-systems',
		},
	},
]

export default subscriptions
